import { Directive, Input } from '@angular/core';
import { LayoutElementDirective } from './layout-element.directive';

@Directive({
  selector: '[am-layout-right]',
})
export class LayoutRightDirective extends LayoutElementDirective {
  @Input() width = '300px';
}
